<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">Dashboard</h5>
    <div class="utc-clock">
        <i class="ri-time-line"></i>
        <span>{{ bstNow }}</span>
    </div>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            <a routerLink="/dashboard" class="d-inline-block position-relative">
                <i class="ri-home-8-line"></i>
                Dashboard
            </a>
        </li>
    </ol>
</div>

<!-- ── Location Mapping Alerts (full width, optional) ────────────────────── -->
<!-- <div class="row" *ngIf="locationAlerts.length > 0">
    <div class="col-12 mb-25">
        <div class="alert-banner alert-banner-warn">...</div>
    </div>
</div> -->

<div class="dashboard-section-heading">
    <div class="dashboard-section-heading-inner">
        <span class="dashboard-section-icon"><i class="ri-links-line"></i></span>
        <div>
            <h4 class="dashboard-section-title">Integration Status</h4>
            <p class="dashboard-section-subtitle">Live connection health for ShipEarly and Linnworks integrations.</p>
        </div>
    </div>
    <span class="dashboard-section-divider"></span>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════
     ROW 1 — Integration Status (full width)
     ══════════════════════════════════════════════════════════════════════════ -->
<div class="row align-items-stretch">

    <!-- ── Integration Status ──────────────────────────────────────────────── -->
    <div class="col-xl-12 col-lg-12 col-md-12 mb-25">
        <mat-card class="daxa-card border-radius border-none d-block h-100">
            <mat-card-content>
                <div class="section-header">
                    <div class="section-header-left">
                        <i class="ri-plug-line"></i>
                        <div>
                            <h5>Integration Status</h5>
                            <p>Live connection status for third-party integrations.</p>
                        </div>
                    </div>
                    <button mat-button class="btn-refresh" (click)="checkConnections()" [disabled]="checking">
                        <i class="ri-refresh-line" [class.spinning]="checking"></i>
                        {{ checking ? 'Checking...' : 'Refresh' }}
                    </button>
                </div>

                <div class="card-body-pad">
                <div class="integration-grid">

                    <!-- ShipEarly -->
                    <div class="integration-card" [ngClass]="getCardClass(shipearly.status)">
                        <div class="int-card-top">
                            <div class="int-logo-wrap" [ngClass]="getLogoClass(shipearly.status)">
                                <i class="ri-ship-line"></i>
                            </div>
                            <div class="int-status-badge" [ngClass]="getBadgeClass(shipearly.status)">
                                <span class="status-dot" [ngClass]="getDotClass(shipearly.status)"></span>
                                {{ getStatusLabel(shipearly.status) }}
                            </div>
                        </div>
                        <div class="int-card-body">
                            <h6>ShipEarly</h6>
                            <p>Shipping &amp; fulfilment</p>
                        </div>
                        <div class="int-card-meta">
                            <span *ngIf="shipearly.connection_checked_at" class="last-checked">
                                <i class="ri-time-line"></i>
                                Status verified: {{ formatDateTime(shipearly.connection_checked_at) }}
                            </span>
                            <span *ngIf="shipearly.lastChecked" class="last-checked">
                                <i class="ri-time-line"></i>
                                Last checked: {{ formatDateTime(shipearly.lastChecked) }}
                            </span>
                            <span *ngIf="shipearly.error" class="int-error">
                                <i class="ri-error-warning-line"></i> {{ shipearly.error }}
                            </span>
                        </div>
                    </div>

                    <!-- Linnworks -->
                    <div class="integration-card" [ngClass]="getCardClass(linnworks.status)">
                        <div class="int-card-top">
                            <div class="int-logo-wrap" [ngClass]="getLogoClass(linnworks.status)">
                                <i class="ri-store-line"></i>
                            </div>
                            <div class="int-status-badge" [ngClass]="getBadgeClass(linnworks.status)">
                                <span class="status-dot" [ngClass]="getDotClass(linnworks.status)"></span>
                                {{ getStatusLabel(linnworks.status) }}
                            </div>
                        </div>
                        <div class="int-card-body">
                            <h6>Linnworks</h6>
                            <p>Inventory &amp; order management</p>
                        </div>
                        <div class="int-card-meta">
                            <span *ngIf="linnworks.connection_checked_at" class="last-checked">
                                <i class="ri-time-line"></i>
                                Status verified: {{ formatDateTime(linnworks.connection_checked_at) }}
                            </span>
                            <span *ngIf="linnworks.lastChecked" class="last-checked">
                                <i class="ri-time-line"></i>
                                Last checked: {{ formatDateTime(linnworks.lastChecked) }}
                            </span>
                            <span *ngIf="linnworks.error" class="int-error">
                                <i class="ri-error-warning-line"></i> {{ linnworks.error }}
                            </span>
                        </div>
                    </div>

                </div>
                </div><!-- /card-body-pad -->
            </mat-card-content>
        </mat-card>
    </div>

    <!-- ── Inventory Sync — Last Run ───────────────────────────────────────── -->
    
</div>
<!-- /ROW 1 -->

<div class="dashboard-section-heading">
    <div class="dashboard-section-heading-inner">
        <span class="dashboard-section-icon"><i class="ri-archive-2-line"></i></span>
        <div>
            <h4 class="dashboard-section-title">Inventory Sync</h4>
            <p class="dashboard-section-subtitle">Delta sync and full reconciliation stats between ShipEarly and Linnworks.</p>
        </div>
    </div>
    <span class="dashboard-section-divider"></span>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════
     ROW 2 — Last 7 Days (left 7/12) | Sync Cursors (right 5/12)
     ══════════════════════════════════════════════════════════════════════════ -->

<div class="row align-items-stretch">
<div class="col-xl-12 col-lg-12 col-md-12 mb-25">
        <mat-card class="daxa-card border-radius border-none d-block h-100">
            <mat-card-content>
                <div class="section-header">
                    <div class="section-header-left">
                        <i class="ri-bar-chart-box-line"></i>
                        <div>
                            <h5>Inventory Sync — Last Run</h5>
                            <p>Stats from the most recent delta and full reconciliation jobs.</p>
                        </div>
                    </div>
                    <button mat-button class="btn-refresh" (click)="loadCronStats()" [disabled]="loadingStats">
                        <i class="ri-refresh-line" [class.spinning]="loadingStats"></i>
                        {{ loadingStats ? 'Loading...' : 'Refresh' }}
                    </button>
                </div>

                <div *ngIf="loadingStats" class="cron-stats-loading">
                    <i class="ri-loader-4-line spinning"></i>
                    <span>Fetching latest sync stats…</span>
                </div>

                <div class="card-body-pad">
                <div *ngIf="!loadingStats" class="cron-stats-grid">

                    <!-- Delta sync card (hidden) -->
                    <div class="cron-stat-card" style="display: none;" [ngClass]="getCronCardClass(deltaStat)">
                        <div class="cron-stat-header">
                            <div class="cron-stat-icon" [ngClass]="getCronIconClass(deltaStat)">
                                <i class="ri-git-branch-line"></i>
                            </div>
                            <div class="cron-stat-label">
                                <span class="cron-type-badge badge-delta">Delta Sync</span>
                                <span class="cron-schedule">Every 15 min</span>
                            </div>
                            <div class="cron-status-badge" [ngClass]="getCronStatusClass(deltaStat)">
                                <span class="status-dot" [ngClass]="getCronDotClass(deltaStat)"></span>
                                {{ getCronStatusLabel(deltaStat) }}
                            </div>
                        </div>

                        <div *ngIf="deltaStat; else noDataDelta" class="cron-stat-body">
                            <div *ngIf="deltaStat.status === 'running'; else deltaContent" class="cron-running-state">
                                <i class="ri-loader-4-line spinning"></i>
                                <span>Job is currently in progress…</span>
                                <div class="cron-meta-row">
                                    <i class="ri-time-line"></i>
                                    <span>Started at: {{ formatDateTime(deltaStat.started_at) }}</span>
                                </div>
                            </div>
                            <ng-template #deltaContent>
                                <div *ngIf="deltaStat.result?.action_required; else deltaCounters" class="cron-action-required">
                                    <i class="ri-alert-line"></i>
                                    <span>{{ deltaStat.result?.action_required }}</span>
                                </div>
                                <ng-template #deltaCounters>
                                    <div class="cron-counters">
                                        <div class="cron-counter counter-pushed">
                                            <span class="counter-value">{{ deltaStat.result?.pushed ?? '—' }}</span>
                                            <span class="counter-label">Pushed</span>
                                        </div>
                                        <div class="cron-counter counter-skipped">
                                            <span class="counter-value">{{ deltaStat.result?.skipped ?? '—' }}</span>
                                            <span class="counter-label">Skipped</span>
                                        </div>
                                        <div class="cron-counter counter-failed">
                                            <span class="counter-value">{{ deltaStat.result?.failed ?? '—' }}</span>
                                            <span class="counter-label">Failed</span>
                                        </div>
                                    </div>
                                </ng-template>
                                <div class="cron-meta-row" *ngIf="deltaStat.result?.window_from">
                                    <i class="ri-calendar-line"></i>
                                    <span>Window: {{ formatDateTime(deltaStat.result?.window_from) }} → {{ formatDateTime(deltaStat.result?.window_to) }}</span>
                                </div>
                                <div class="cron-meta-row">
                                    <i class="ri-time-line"></i>
                                    <span>Ran at: {{ formatDateTime(deltaStat.started_at) }}</span>
                                    <span *ngIf="deltaStat.duration_seconds != null" class="cron-duration">
                                        {{ formatDuration(deltaStat.duration_seconds) }}
                                    </span>
                                </div>
                                <div class="cron-meta-row" *ngIf="deltaStat.error_message">
                                    <i class="ri-error-warning-line" style="color:#dc2626"></i>
                                    <span class="cron-error-text">{{ deltaStat.error_message }}</span>
                                </div>
                            </ng-template>
                        </div>
                        <ng-template #noDataDelta>
                            <div class="cron-no-data">
                                <i class="ri-information-line"></i> No runs recorded yet
                            </div>
                        </ng-template>
                    </div>

                    <!-- Full recon card -->
                    <div class="cron-stat-card" [ngClass]="getCronCardClass(reconStat)">
                        <div class="cron-stat-header">
                            <div class="cron-stat-icon" [ngClass]="getCronIconClass(reconStat)">
                                <i class="ri-database-2-line"></i>
                            </div>
                            <div class="cron-stat-label">
                                <span class="cron-type-badge badge-recon">Full Recon</span>
                                <span class="cron-schedule">Every 2 hours</span>
                            </div>
                            <div class="cron-status-badge" [ngClass]="getCronStatusClass(reconStat)">
                                <span class="status-dot" [ngClass]="getCronDotClass(reconStat)"></span>
                                {{ getCronStatusLabel(reconStat) }}
                            </div>
                        </div>

                        <div *ngIf="reconStat; else noDataRecon" class="cron-stat-body">
                            <div *ngIf="reconStat.status === 'running'; else reconContent" class="cron-running-state">
                                <i class="ri-loader-4-line spinning"></i>
                                <span>Job is currently in progress…</span>
                                <div class="cron-meta-row">
                                    <i class="ri-time-line"></i>
                                    <span>Started at: {{ formatDateTime(reconStat.started_at) }}</span>
                                </div>
                            </div>
                            <ng-template #reconContent>
                                <div *ngIf="reconStat.result?.action_required; else reconCounters" class="cron-action-required">
                                    <i class="ri-alert-line"></i>
                                    <span>{{ reconStat.result?.action_required }}</span>
                                </div>
                                <ng-template #reconCounters>
                                    <div class="cron-counters">
                                        <div class="cron-counter counter-pushed">
                                            <span class="counter-value">{{ reconStat.result?.pushed ?? '—' }}</span>
                                            <span class="counter-label">Pushed</span>
                                        </div>
                                        <div class="cron-counter counter-skipped">
                                            <span class="counter-value">{{ reconStat.result?.skipped ?? '—' }}</span>
                                            <span class="counter-label">Skipped</span>
                                        </div>
                                        <div class="cron-counter counter-failed">
                                            <span class="counter-value">{{ reconStat.result?.failed ?? '—' }}</span>
                                            <span class="counter-label">Failed</span>
                                        </div>
                                    </div>
                                </ng-template>
                                <div class="cron-meta-row" *ngIf="reconStat.result?.se_warehouses != null">
                                    <i class="ri-store-2-line"></i>
                                    <span>SE warehouses synced: <strong>{{ reconStat.result?.se_warehouses }}</strong></span>
                                </div>
                                <div class="cron-meta-row">
                                    <i class="ri-time-line"></i>
                                    <span>Ran at: {{ formatDateTime(reconStat.started_at) }}</span>
                                    <span *ngIf="reconStat.duration_seconds != null" class="cron-duration">
                                        {{ formatDuration(reconStat.duration_seconds) }}
                                    </span>
                                </div>
                                <div class="cron-meta-row" *ngIf="reconStat.error_message">
                                    <i class="ri-error-warning-line" style="color:#dc2626"></i>
                                    <span class="cron-error-text">{{ reconStat.error_message }}</span>
                                </div>
                            </ng-template>
                        </div>
                        <ng-template #noDataRecon>
                            <div class="cron-no-data">
                                <i class="ri-information-line"></i> No runs recorded yet
                            </div>
                        </ng-template>
                    </div>

                </div>
                </div><!-- /card-body-pad -->
            </mat-card-content>
        </mat-card>
    </div>

</div>
<!-- /ROW 1b -->

<div class="row align-items-stretch" style="display: none;"><!-- ROW 2 hidden: Last 7 Days + Sync Cursors -->

    <!-- ── Last 7 Days (hidden) ────────────────────────────────────────────── -->
    <div class="col-xl-7 col-lg-7 col-md-12 mb-25" style="display: none;">
        <mat-card class="daxa-card border-radius border-none d-block h-100">
            <mat-card-content>
                <div class="section-header">
                    <div class="section-header-left">
                        <i class="ri-line-chart-line"></i>
                        <div>
                            <h5>Last 7 Days</h5>
                            <p>Aggregated sync activity across both job schedules.</p>
                        </div>
                    </div>
                    <button mat-button class="btn-help" (click)="helpBoxOpen = !helpBoxOpen"
                            [class.btn-help-active]="helpBoxOpen"
                            title="What do these numbers mean?">
                        <i class="ri-question-line"></i>
                        What do these mean?
                    </button>
                </div>

                <!-- Help box -->
                <div class="help-box" *ngIf="helpBoxOpen">
                    <div class="help-box-header">
                        <div class="help-box-title">
                            <i class="ri-lightbulb-flash-line"></i>
                            Understanding your sync counters
                        </div>
                        <button class="help-box-close" (click)="helpBoxOpen = false">
                            <i class="ri-close-line"></i>
                        </button>
                    </div>
                    <div class="help-box-grid">
                        <div class="help-item help-neutral">
                            <div class="help-item-head">
                                <span class="help-badge neutral">Runs</span>
                            </div>
                            <p>How many times the job has run in the last 7 days. The delta sync fires every 15 minutes, so 52 runs ≈ 13 hours of active operation. Full Recon runs every 2 hours.</p>
                        </div>
                        <div class="help-item help-success">
                            <div class="help-item-head">
                                <span class="help-badge success">OK</span>
                            </div>
                            <p>Runs that finished without any problems. A run counts as OK even when there were no stock changes to process — it simply means the job completed normally and saved its progress.</p>
                        </div>
                        <div class="help-item help-danger">
                            <div class="help-item-head">
                                <span class="help-badge danger">Failed</span>
                            </div>
                            <p>Runs that stopped unexpectedly due to a connection problem, authentication issue, or a service being temporarily unavailable. Investigate these if the number is above zero.</p>
                        </div>
                        <div class="help-item help-info">
                            <div class="help-item-head">
                                <span class="help-badge info">Pushed</span>
                            </div>
                            <p>Products that were successfully sent to ShipEarly. A zero here means either no stock changes were detected in Linnworks during this period, or an active filter is limiting which products are synced.</p>
                        </div>
                        <div class="help-item help-warning">
                            <div class="help-item-head">
                                <span class="help-badge warning">Skipped</span>
                            </div>
                            <p>Products that were checked but not sent — either because nothing changed since the last sync (no point re-sending identical data), or because an active product filter excluded them.</p>
                        </div>
                        <div class="help-item help-orange">
                            <div class="help-item-head">
                                <span class="help-badge orange">SKU Fail</span>
                            </div>
                            <p>Individual products that encountered an error during their own sync attempt — for example, ShipEarly rejected a specific variant or Linnworks returned no data for it. These don't stop the whole run; other products continue processing.</p>
                        </div>
                    </div>
                </div>

                <div *ngIf="loadingAgg" class="cron-stats-loading">
                    <i class="ri-loader-4-line spinning"></i>
                    <span>Loading aggregates…</span>
                </div>

                <div *ngIf="!loadingAgg" class="agg-grid">

                    <!-- Delta -->
                    <div class="agg-card">
                        <div class="agg-card-title">
                            <span class="cron-type-badge badge-delta">Delta</span>
                        </div>
                        <div class="agg-counters">
                            <div class="agg-counter">
                                <span class="agg-value">{{ deltaAgg?.total_runs ?? '—' }}</span>
                                <span class="agg-label">Runs</span>
                            </div>
                            <div class="agg-counter agg-success">
                                <span class="agg-value">{{ deltaAgg?.successful ?? '—' }}</span>
                                <span class="agg-label">OK</span>
                            </div>
                            <div class="agg-counter agg-failed">
                                <span class="agg-value">{{ deltaAgg?.failed_runs ?? '—' }}</span>
                                <span class="agg-label">Failed</span>
                            </div>
                            <div class="agg-counter agg-pushed">
                                <span class="agg-value">{{ deltaAgg?.total_pushed ?? '—' }}</span>
                                <span class="agg-label">Pushed</span>
                            </div>
                            <div class="agg-counter agg-skipped">
                                <span class="agg-value">{{ deltaAgg?.total_skipped ?? '—' }}</span>
                                <span class="agg-label">Skipped</span>
                            </div>
                            <div class="agg-counter agg-sku-fail">
                                <span class="agg-value">{{ deltaAgg?.total_sku_failures ?? '—' }}</span>
                                <span class="agg-label">SKU Fail</span>
                            </div>
                        </div>
                        <div class="agg-footer" *ngIf="deltaAgg?.avg_duration_sec != null">
                            <i class="ri-timer-line"></i>
                            Avg: <strong>{{ formatDuration(deltaAgg?.avg_duration_sec) }}</strong>
                            <span class="agg-footer-sep">·</span>
                            Max: <strong>{{ formatDuration(deltaAgg?.max_duration_sec) }}</strong>
                        </div>
                    </div>

                    <!-- Full Recon -->
                    <div class="agg-card">
                        <div class="agg-card-title">
                            <span class="cron-type-badge badge-recon">Full Recon</span>
                        </div>
                        <div class="agg-counters">
                            <div class="agg-counter">
                                <span class="agg-value">{{ reconAgg?.total_runs ?? '—' }}</span>
                                <span class="agg-label">Runs</span>
                            </div>
                            <div class="agg-counter agg-success">
                                <span class="agg-value">{{ reconAgg?.successful ?? '—' }}</span>
                                <span class="agg-label">OK</span>
                            </div>
                            <div class="agg-counter agg-failed">
                                <span class="agg-value">{{ reconAgg?.failed_runs ?? '—' }}</span>
                                <span class="agg-label">Failed</span>
                            </div>
                            <div class="agg-counter agg-pushed">
                                <span class="agg-value">{{ reconAgg?.total_pushed ?? '—' }}</span>
                                <span class="agg-label">Pushed</span>
                            </div>
                            <div class="agg-counter agg-skipped">
                                <span class="agg-value">{{ reconAgg?.total_skipped ?? '—' }}</span>
                                <span class="agg-label">Skipped</span>
                            </div>
                            <div class="agg-counter agg-sku-fail">
                                <span class="agg-value">{{ reconAgg?.total_sku_failures ?? '—' }}</span>
                                <span class="agg-label">SKU Fail</span>
                            </div>
                        </div>
                        <div class="agg-footer" *ngIf="reconAgg?.avg_duration_sec != null">
                            <i class="ri-timer-line"></i>
                            Avg: <strong>{{ formatDuration(reconAgg?.avg_duration_sec) }}</strong>
                            <span class="agg-footer-sep">·</span>
                            Max: <strong>{{ formatDuration(reconAgg?.max_duration_sec) }}</strong>
                        </div>
                    </div>

                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- ── Sync Cursors (hidden) ───────────────────────────────────────────── -->
    <div class="col-xl-5 col-lg-5 col-md-12 mb-25" style="display: none;">
        <mat-card class="daxa-card border-radius border-none d-block h-100">
            <mat-card-content>
                <div class="section-header">
                    <div class="section-header-left">
                        <i class="ri-bookmark-line"></i>
                        <div>
                            <h5>Sync Cursors</h5>
                            <p>Last successfully committed watermark for each job.</p>
                        </div>
                    </div>
                </div>

                <div class="card-body-pad">
                <div class="cursor-grid">
                    <div class="cursor-card">
                        <span class="cron-type-badge badge-delta">Delta</span>
                        <div class="cursor-value" *ngIf="cursorDelta; else noCursor">
                            <i class="ri-time-line"></i>
                            {{ formatDateTime(cursorDelta.last_success_at) }}
                            <!-- <span class="cursor-ago">{{ cursorDelta.minutes_ago }} min ago</span> -->
                        </div>
                        <ng-template #noCursor>
                            <span class="cursor-none">Not yet committed</span>
                        </ng-template>
                    </div>
                    <div class="cursor-card">
                        <span class="cron-type-badge badge-recon">Full Recon</span>
                        <div class="cursor-value" *ngIf="cursorRecon; else noReconCursor">
                            <i class="ri-time-line"></i>
                            {{ formatDateTime(cursorRecon.last_success_at) }}
                            <!-- <span class="cursor-ago">{{ cursorRecon.minutes_ago }} min ago</span> -->
                        </div>
                        <ng-template #noReconCursor>
                            <span class="cursor-none">Not yet committed</span>
                        </ng-template>
                    </div>
                </div>
                </div><!-- /card-body-pad -->
            </mat-card-content>
        </mat-card>
    </div>

</div>
<!-- /ROW 2 -->

<!-- ════════════════════════════════════════════════════════════════════════════
     ROW 3 — Order Sync Last Run (left 7/12) | Order Cursor & Quarantine (right 5/12)
     ════════════════════════════════════════════════════════════════════════════ -->
<div class="dashboard-section-heading">
    <div class="dashboard-section-heading-inner">
        <span class="dashboard-section-icon"><i class="ri-shopping-cart-2-line"></i></span>
        <div>
            <h4 class="dashboard-section-title">Order Sync</h4>
            <p class="dashboard-section-subtitle">SE → LW order sync job stats, quarantine queue and sync cursor.</p>
        </div>
    </div>
    <span class="dashboard-section-divider"></span>
</div>

<div class="row align-items-stretch">

    <!-- ── Order Sync — Last Run ─────────────────────────────────────────── -->
    <div class="col-xl-12 col-lg-12 col-md-12 mb-25">
        <mat-card class="daxa-card border-radius border-none d-block h-100">
            <mat-card-content>
                <div class="section-header">
                    <div class="section-header-left">
                        <i class="ri-shopping-cart-line"></i>
                        <div>
                            <h5>Order Sync — Last Run</h5>
                            <p>Stats from the most recent SE→LW order sync and quarantine retry jobs.</p>
                        </div>
                    </div>
                    <button mat-button class="btn-refresh" (click)="loadOrderCronStats()" [disabled]="loadingOrderStats">
                        <i class="ri-refresh-line" [class.spinning]="loadingOrderStats"></i>
                        {{ loadingOrderStats ? 'Loading...' : 'Refresh' }}
                    </button>
                </div>

                <div *ngIf="loadingOrderStats" class="cron-stats-loading">
                    <i class="ri-loader-4-line spinning"></i>
                    <span>Fetching latest order sync stats…</span>
                </div>

                <div class="card-body-pad">
                <div *ngIf="!loadingOrderStats" class="cron-stats-grid">

                    <!-- Order Sync (SE→LW) -->
                    <div class="cron-stat-card" [ngClass]="getOrderCronCardClass(orderSyncStat)">
                        <div class="cron-stat-header">
                            <div class="cron-stat-icon" [ngClass]="getOrderCronIconClass(orderSyncStat)">
                                <i class="ri-arrow-right-circle-line"></i>
                            </div>
                            <div class="cron-stat-label">
                                <span class="cron-type-badge badge-order-sync">Order Sync</span>
                                <span class="cron-schedule">Every 10 min</span>
                            </div>
                            <div class="cron-status-badge" [ngClass]="getOrderCronStatusClass(orderSyncStat)">
                                <span class="status-dot" [ngClass]="getOrderCronDotClass(orderSyncStat)"></span>
                                {{ getOrderCronStatusLabel(orderSyncStat) }}
                            </div>
                        </div>
                        <div *ngIf="orderSyncStat; else noDataOrderSync" class="cron-stat-body">
                            <div *ngIf="orderSyncStat.status === 'running'; else orderSyncContent" class="cron-running-state">
                                <i class="ri-loader-4-line spinning"></i>
                                <span>Job is currently in progress…</span>
                                <div class="cron-meta-row">
                                    <i class="ri-time-line"></i>
                                    <span>Started at: {{ formatDateTime(orderSyncStat.started_at) }}</span>
                                </div>
                            </div>
                            <ng-template #orderSyncContent>
                                <div class="cron-counters">
                                    <div class="cron-counter counter-pushed">
                                        <span class="counter-value">{{ orderSyncStat.result?.created ?? '—' }}</span>
                                        <span class="counter-label">Created</span>
                                    </div>
                                    <div class="cron-counter counter-skipped">
                                        <span class="counter-value">{{ orderSyncStat.result?.updated ?? '—' }}</span>
                                        <span class="counter-label">Updated</span>
                                    </div>
                                    <div class="cron-counter counter-skipped">
                                        <span class="counter-value">{{ orderSyncStat.result?.skipped ?? '—' }}</span>
                                        <span class="counter-label">Skipped</span>
                                    </div>
                                    <div class="cron-counter" [class.counter-failed]="(orderSyncStat.result?.quarantined ?? 0) > 0">
                                        <span class="counter-value">{{ orderSyncStat.result?.quarantined ?? '—' }}</span>
                                        <span class="counter-label">Quarantined</span>
                                    </div>
                                    <div class="cron-counter counter-failed">
                                        <span class="counter-value">{{ orderSyncStat.result?.failed ?? '—' }}</span>
                                        <span class="counter-label">Failed</span>
                                    </div>
                                </div>
                                <div class="cron-meta-row" *ngIf="orderSyncStat.result?.window_from">
                                    <i class="ri-calendar-line"></i>
                                    <span>Window: {{ formatDateTime(orderSyncStat.result?.window_from) }} → {{ formatDateTime(orderSyncStat.result?.window_to) }}</span>
                                </div>
                                <div class="cron-meta-row" *ngIf="orderSyncStat.result?.polled != null">
                                    <i class="ri-store-2-line"></i>
                                    <span>SE orders polled: <strong>{{ orderSyncStat.result?.polled }}</strong></span>
                                </div>
                                <div class="cron-meta-row">
                                    <i class="ri-time-line"></i>
                                    <span>Ran at: {{ formatDateTime(orderSyncStat.started_at) }}</span>
                                    <span *ngIf="orderSyncStat.duration_seconds != null" class="cron-duration">
                                        {{ formatDuration(orderSyncStat.duration_seconds) }}
                                    </span>
                                </div>
                                <div class="cron-meta-row" *ngIf="orderSyncStat.error_message">
                                    <i class="ri-error-warning-line" style="color:#dc2626"></i>
                                    <span class="cron-error-text">{{ orderSyncStat.error_message }}</span>
                                </div>
                            </ng-template>
                        </div>
                        <ng-template #noDataOrderSync>
                            <div class="cron-no-data"><i class="ri-information-line"></i> No runs recorded yet</div>
                        </ng-template>
                    </div>

                    <!-- Quarantine Retry (hidden) -->
                    <div class="cron-stat-card" style="display: none;" [ngClass]="getOrderCronCardClass(orderQuarantineRetryStat)">
                        <div class="cron-stat-header">
                            <div class="cron-stat-icon" [ngClass]="getOrderCronIconClass(orderQuarantineRetryStat)">
                                <i class="ri-repeat-line"></i>
                            </div>
                            <div class="cron-stat-label">
                                <span class="cron-type-badge badge-quarantine">Quarantine Retry</span>
                                <span class="cron-schedule">Every 30 min</span>
                            </div>
                            <div class="cron-status-badge" [ngClass]="getOrderCronStatusClass(orderQuarantineRetryStat)">
                                <span class="status-dot" [ngClass]="getOrderCronDotClass(orderQuarantineRetryStat)"></span>
                                {{ getOrderCronStatusLabel(orderQuarantineRetryStat) }}
                            </div>
                        </div>
                        <div *ngIf="orderQuarantineRetryStat; else noDataQRetry" class="cron-stat-body">
                            <div *ngIf="orderQuarantineRetryStat.status === 'running'; else qRetryContent" class="cron-running-state">
                                <i class="ri-loader-4-line spinning"></i>
                                <span>Job is currently in progress…</span>
                                <div class="cron-meta-row">
                                    <i class="ri-time-line"></i>
                                    <span>Started at: {{ formatDateTime(orderQuarantineRetryStat.started_at) }}</span>
                                </div>
                            </div>
                            <ng-template #qRetryContent>
                                <div class="cron-counters">
                                    <div class="cron-counter counter-pushed">
                                        <span class="counter-value">{{ orderQuarantineRetryStat.result?.created ?? '—' }}</span>
                                        <span class="counter-label">Resolved</span>
                                    </div>
                                    <div class="cron-counter" [class.counter-failed]="(orderQuarantineRetryStat.result?.quarantined ?? 0) > 0">
                                        <span class="counter-value">{{ orderQuarantineRetryStat.result?.quarantined ?? '—' }}</span>
                                        <span class="counter-label">Still Quarantined</span>
                                    </div>
                                    <div class="cron-counter counter-failed">
                                        <span class="counter-value">{{ orderQuarantineRetryStat.result?.failed ?? '—' }}</span>
                                        <span class="counter-label">Failed</span>
                                    </div>
                                </div>
                                <div class="cron-meta-row">
                                    <i class="ri-time-line"></i>
                                    <span>Ran at: {{ formatDateTime(orderQuarantineRetryStat.started_at) }}</span>
                                    <span *ngIf="orderQuarantineRetryStat.duration_seconds != null" class="cron-duration">
                                        {{ formatDuration(orderQuarantineRetryStat.duration_seconds) }}
                                    </span>
                                </div>
                                <div class="cron-meta-row" *ngIf="orderQuarantineRetryStat.error_message">
                                    <i class="ri-error-warning-line" style="color:#dc2626"></i>
                                    <span class="cron-error-text">{{ orderQuarantineRetryStat.error_message }}</span>
                                </div>
                            </ng-template>
                        </div>
                        <ng-template #noDataQRetry>
                            <div class="cron-no-data"><i class="ri-information-line"></i> No runs recorded yet</div>
                        </ng-template>
                    </div>

                </div>
                </div><!-- /card-body-pad -->
            </mat-card-content>
        </mat-card>
    </div>

    <!-- ── Order Sync Cursor & Quarantine (hidden) ─────────────────────────── -->
    <div class="col-xl-5 col-lg-5 col-md-12 mb-25" style="display: none;">
        <mat-card class="daxa-card border-radius border-none d-block h-100">
            <mat-card-content>
                <div class="section-header">
                    <div class="section-header-left">
                        <i class="ri-bookmark-line"></i>
                        <div>
                            <h5>Order Sync Cursor &amp; Quarantine</h5>
                            <p>Last committed watermark and quarantine queue status.</p>
                        </div>
                    </div>
                </div>
                <div class="card-body-pad">

                    <!-- Cursor -->
                    <div class="cursor-grid" style="margin-bottom:16px">
                        <div class="cursor-card">
                            <span class="cron-type-badge badge-order-sync">Order Sync Cursor</span>
                            <div class="cursor-value" *ngIf="cursorOrderSync; else noOrderCursor">
                                <i class="ri-time-line"></i>
                                {{ formatDateTime(cursorOrderSync.last_success_at) }}
                            </div>
                            <ng-template #noOrderCursor>
                                <span class="cursor-none">Not yet committed</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- Quarantine summary -->
                    <div *ngIf="orderQuarantineSummary" class="quarantine-summary">
                        <div class="quarantine-header">
                            <i class="ri-error-warning-line"></i>
                            <span>Quarantine Queue</span>
                        </div>
                        <div class="quarantine-counters">
                            <div class="quarantine-counter qc-total">
                                <span class="qc-value">{{ orderQuarantineSummary.total_quarantined }}</span>
                                <span class="qc-label">Total</span>
                            </div>
                            <div class="quarantine-counter qc-unresolved" [class.qc-alert]="orderQuarantineSummary.unresolved > 0">
                                <span class="qc-value">{{ orderQuarantineSummary.unresolved }}</span>
                                <span class="qc-label">Unresolved</span>
                            </div>
                            <div class="quarantine-counter qc-resolved">
                                <span class="qc-value">{{ orderQuarantineSummary.resolved }}</span>
                                <span class="qc-label">Resolved</span>
                            </div>
                        </div>
                        <p class="quarantine-hint" *ngIf="orderQuarantineSummary.unresolved > 0">
                            <i class="ri-alert-line"></i>
                            {{ orderQuarantineSummary.unresolved }} order(s) are waiting for missing SKUs to be added to Linnworks.
                        </p>
                    </div>

                    <!-- 7-day order sync aggregates -->
                    <div *ngIf="!loadingOrderAgg && orderSyncAgg" style="margin-top:16px">
                        <div class="agg-card">
                            <div class="agg-card-title">
                                <span class="cron-type-badge badge-order-sync">7-Day Order Sync</span>
                            </div>
                            <div class="agg-counters">
                                <div class="agg-counter">
                                    <span class="agg-value">{{ orderSyncAgg.total_runs ?? '—' }}</span>
                                    <span class="agg-label">Runs</span>
                                </div>
                                <div class="agg-counter agg-success">
                                    <span class="agg-value">{{ orderSyncAgg.successful ?? '—' }}</span>
                                    <span class="agg-label">OK</span>
                                </div>
                                <div class="agg-counter agg-failed">
                                    <span class="agg-value">{{ orderSyncAgg.failed_runs ?? '—' }}</span>
                                    <span class="agg-label">Failed</span>
                                </div>
                                <div class="agg-counter agg-pushed">
                                    <span class="agg-value">{{ orderSyncAgg.total_pushed ?? '—' }}</span>
                                    <span class="agg-label">Synced</span>
                                </div>
                                <div class="agg-counter agg-skipped">
                                    <span class="agg-value">{{ orderSyncAgg.total_skipped ?? '—' }}</span>
                                    <span class="agg-label">Skipped</span>
                                </div>
                                <div class="agg-counter agg-sku-fail">
                                    <span class="agg-value">{{ orderSyncAgg.total_sku_failures ?? '—' }}</span>
                                    <span class="agg-label">Failed</span>
                                </div>
                            </div>
                            <div class="agg-footer" *ngIf="orderSyncAgg.avg_duration_sec != null">
                                <i class="ri-timer-line"></i>
                                Avg: <strong>{{ formatDuration(orderSyncAgg.avg_duration_sec) }}</strong>
                                <span class="agg-footer-sep">·</span>
                                Max: <strong>{{ formatDuration(orderSyncAgg.max_duration_sec) }}</strong>
                            </div>
                        </div>
                    </div>

                </div><!-- /card-body-pad -->
            </mat-card-content>
        </mat-card>
    </div>

</div>
<!-- /ROW 3 -->